/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Breadcrumb, Footer, Navbar } from '../components';
import { dataLayerPush } from '../helpers/dataLayer';
import {
  addItemToLocalStorage,
  removeItemFromLocalStorage,
  removeAllThatItemFromLocalStorage,
} from '../helpers/handleCartLocalStorage';
import { Link } from 'react-router-dom';

const Cart = () => {
  const [state, setState] = React.useState(
    localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [],
  );

  const EmptyCart = () => {
    return (
      <div className='container my-5 py-2'>
        <div className='row' style={{ background: '#fff' }}>
          <div className='col-md-12 py-5 bg-light text-center'>
            <h2 className='p-3 fw-light'>Your Cart is Empty</h2>
            <a href='/' className='btn  btn-outline-dark mx-4 my-5'>
              <i className='fa fa-arrow-left'></i> Continue Shopping
            </a>
          </div>
        </div>
      </div>
    );
  };

  const addItem = (product) => {
    addItemToLocalStorage(product);
    setState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);
    dataLayerPush({
      event: 'addToCart',
      pageType: 'detail',
      pageName: 'cart',
      product: product,
    });
  };
  const removeItem = (product) => {
    removeItemFromLocalStorage(product);
    setState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);
    dataLayerPush({
      event: 'removeFromCart',
      pageType: 'detail',
      pageName: 'cart',
      product: product,
    });
  };

  const removeAll = (product) => {
    removeAllThatItemFromLocalStorage(product);
    setState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);
    dataLayerPush({
      event: 'removeAllFromCart',
      pageType: 'detail',
      pageName: 'cart',
      product: product,
    });
  };

  const ShowCart = () => {
    let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;
    state.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });

    dataLayerPush({
      event: 'pageView',
      pageType: 'detail',
      pageName: 'cart',
      cart: state,
      subtotal: subtotal,
      totalItems: totalItems,
      price: subtotal + shipping,
    });

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return (
      <>
        <section className='h-100 gradient-custom'>
          <div className='container py-2'>
            <div className='row d-flex justify-content-center'>
              <div className='col-md-8'>
                <p className='text-start mt-5 fs-5' style={{ borderBottom: '1px solid #ddd', background: '#fff' }}>
                  Cart
                </p>
                <table className='w-100'>
                  <thead style={{ borderBottom: '1px solid #ddd', background: '#fff', marginBottom: '5px' }}>
                    <tr>
                      <th className='fw-light' style={{ width: '180px' }}></th>
                      <th className='fw-light' style={{ width: '200px' }}>
                        Product
                      </th>
                      <th className='fw-light' style={{ width: '200px' }}>
                        Unit Price
                      </th>
                      <th className='fw-light' style={{ width: '180px' }}>
                        Piece
                      </th>
                      <th className='fw-light' style={{ width: '180px' }}>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className='mt-2'>
                    {state.map((item) => {
                      return (
                        <tr key={item.id} style={{ borderBottom: '1px solid #ddd', background: '#fff' }}>
                          <td style={{ width: '180px' }}>
                            <div className='d-flex align-items-center'>
                              <Link to={`/product/${item.id}`}>
                                <img src={item?.images?.main} alt={item.title} width={100} />
                              </Link>
                            </div>
                          </td>
                          <td style={{ width: '200px' }}>
                            <p>{item.title}</p>
                          </td>
                          <td style={{ width: '200px' }}>${item.price}</td>
                          <td style={{ width: '180px' }}>
                            <div className='d-flex align-items-center'>
                              <button
                                className='btn removeFromCart'
                                onClick={() => {
                                  removeItem(item);
                                }}>
                                <i className='fa fa-minus'></i>
                              </button>
                              <p className='mx-3 pt-3'>{item.qty}</p>
                              <button
                                className='btn  addToCart'
                                onClick={() => {
                                  addItem(item);
                                }}>
                                <i className='fa fa-plus'></i>
                              </button>
                            </div>
                          </td>
                          <td style={{ width: '180px' }}>${(item.price * item.qty).toFixed(2)}</td>
                          <td>
                            <a
                              className='text-decoration-underline text-black'
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                removeAll(item);
                              }}>
                              Delete
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className='col-md-4'>
                <div className='mb-4'>
                  <p className='text-start mt-5 fs-5 mb-0'>Cart Total</p>
                  <div className='card-body px-2 rounded-3' style={{ background: '#F9F9F9' }}>
                    <ul className='list-group list-group-flush pt-2'>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0'
                        style={{ background: '#F9F9F9' }}>
                        Order Total ({totalItems})<span>${Math.round(subtotal)}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center px-0'
                        style={{ background: '#F9F9F9' }}>
                        Shipping
                        <span>${shipping}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 my-3'
                        style={{ background: '#F9F9F9' }}>
                        <h6>Total amount</h6>

                        <h6>${Math.round(subtotal + shipping)}</h6>
                      </li>
                    </ul>
                    <a href='/checkout' className='btn btn-sm btn-dark btn-lg btn-block mb-3 w-100'>
                      Go to checkout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
        <Navbar />
        <div className='container my-5 py-2' style={{ flex: '1' }}>
          <Breadcrumb category='cart' />
          {state.length > 0 ? <ShowCart /> : <EmptyCart />}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Cart;
